import { unwrap, type components } from "@sagot/api-client";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "../../../session/session-provider";
import { useWorkspaceId } from "../../../session/workspace-context";
import { workflowKeys } from "./use-workflows";

type Schemas = components["schemas"];
export type WorkflowSetup = Schemas["WorkflowSetupOut"];

/**
 * What is left before a workflow runs ("Finish setting up"), derived by the server from the saved draft and the workspace.
 * Saving, publishing, pausing or resuming invalidate `workflowKeys.all`, which covers this key, so the list follows the workflow.
 * It is advisory: a failed read leaves the builder usable (no retry loop).
 */
export function useWorkflowSetup(id: string): UseQueryResult<WorkflowSetup> {
  const api = useApi();
  const ws = useWorkspaceId();
  return useQuery({
    queryKey: workflowKeys.setup(ws, id),
    queryFn: () => unwrap(api.GET("/v1/workflows/{workflow_id}/setup", { params: { path: { workflow_id: id } } })),
    retry: false,
  });
}
